import React from "react";
import PropTypes from "prop-types";
import { Box, IconButton, InputAdornment, MenuItem, TextField } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
const SearchBar = ({ searchQuery, onSearchChange, statusFilter, onStatusChange }) => (
  <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", width: "100%" }}>
    <TextField
      label="Buscar grupo, reader, comercio o antena"
      placeholder="Nombre, IP, ID…"
      size="small"
      value={searchQuery}
      onChange={(event) => onSearchChange(event.target.value)}
      sx={{ flex: "1 1 280px" }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: searchQuery ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              aria-label="Limpiar búsqueda"
              onClick={() => onSearchChange("")}
            >
              <Clear fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
    <TextField
      select
      label="Estado del grupo"
      size="small"
      value={statusFilter}
      onChange={(event) => onStatusChange(event.target.value)}
      sx={{
        minWidth: 210,
        flex: "1 1 210px",
        "& .MuiSelect-select": {
          minHeight: "40px !important",
          py: "0 !important",
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      <MenuItem value="todos">Todos los grupos</MenuItem>
      <MenuItem value="activos">Con readers activos</MenuItem>
      <MenuItem value="inactivos">Sin readers activos</MenuItem>
    </TextField>
  </Box>
);
SearchBar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  statusFilter: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};
export default SearchBar;
